module.exports = __webpack_public_path__ + "img/info1_.1e616318.png";